import { Button } from "react-bootstrap";
import { ErrorBox } from "../atoms";

const ErrorFallback = ({ error, resetErrorBoundary }) => {
  return (
    <div role="alert">
      <ErrorBox error={error.message}>
        <Button
          variant="outline-secondary "
          className="mt-4"
          onClick={resetErrorBoundary}
        >
          تلاش مجدد
        </Button>
      </ErrorBox>
    </div>
  );
};
export { ErrorFallback };
